import React, { useEffect } from "react";
import { BrowserRouter, Route, Switch, Redirect } from "react-router-dom";
import AdminLayout from "layouts/Admin.js";
import AuthLayout from "layouts/Auth.js";
import PublicLayout from "layouts/PublicLayout";
import { useSelector } from "react-redux";
import * as Sentry from "@sentry/react";

function App() {
  let { uid, user } = useSelector((state) => state.auth);

  useEffect(() => {
    const clarityId = process.env.REACT_APP_CLARITY_ID;
    if (clarityId) {
      (function (c, l, a, r, i, t, y) {
        c[a] = c[a] || function () { (c[a].q = c[a].q || []).push(arguments); };
        t = l.createElement(r); t.async = 1; t.src = "https://www.clarity.ms/tag/" + i;
        y = l.getElementsByTagName(r)[0]; y.parentNode.insertBefore(t, y);
      })(window, document, "clarity", "script", clarityId);
    }
  }, []);
  return (
    <>
      <BrowserRouter>
        {uid ? (
          <Switch>
            <Route
              path="/admin"
              render={(props) => <AdminLayout {...props} />}
            />
            <Route
              path="/public"
              render={(props) => <PublicLayout {...props} />}
            />
            <Redirect from="/" to="/admin/index" />
          </Switch>
        ) : (
          <Switch>
            <Route path="/auth" render={(props) => <AuthLayout {...props} />} />
            <Redirect from="/" to="/auth/login" />
          </Switch>
        )}
      </BrowserRouter>
    </>
  );
}

export default process.env.NODE_ENV === "production"
  ? Sentry.withErrorBoundary(App, {
      fallback: (
        <div className="d-flex flex-column align-items-center justify-content-center text-danger py-5">
          <div className="fw-bold text-center fs-1">
            Something went wrong. Please try again later. 🚨
          </div>
        </div>
      )
    })
  : App;
